import { render, staticRenderFns } from "./BlockGroupObjects.vue?vue&type=template&id=2ab6809c&scoped=true"
import script from "./BlockGroupObjects.vue?vue&type=script&lang=js"
export * from "./BlockGroupObjects.vue?vue&type=script&lang=js"
import style0 from "./BlockGroupObjects.vue?vue&type=style&index=0&id=2ab6809c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab6809c",
  null
  
)

export default component.exports